import React, { Fragment } from 'react';

const Error404 = (props) => (
    <Fragment>
        <div className="d-flex justify-content-center full-height full-width align-items-center">
            <div className="error-container text-center">
                <h1 className="error-number">404</h1>
                <h2 className="semi-bold">Sorry but we couldn't find this page</h2>
                <p className="p-b-10">This page you are looking for does not exist</p>

                <div className="error-container-innner text-center">
                    <form className="error-form">
                        <div className="transparent text-left">
                            <div className="form-group form-group-default input-group">
                                <div className="form-input-group">
                                    <label>Search</label>
                                    <input className="form-control" placeholder="Try searching the missing page" type="text" />
                                </div>
                                <div className="input-group-append">
                                    <span className="input-group-text transparent">
                                        <span className="pg-search p-l-10" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </Fragment>
);

export default Error404;


// WEBPACK FOOTER //
// ./src/components/base/errors/error-404.js